<article class="customer-packaging-card" [formGroup]="row()">
  <div class="customer-packaging-card__header">
    <puro-typography
      class="customer-packaging-card__title"
      variant="h5-semibold"
      component="h3"
      color="textPrimary"
      tabindex="-1"
      [attr.data-testid]="'package-piece-title-' + index()"
      [attr.id]="'package-piece-title-' + index()"
    >
      {{
        'createShipment.packageStep.details.packageLabel' | translate: { index: '' + (index() + 1) }
      }}
    </puro-typography>
    <div class="customer-packaging-card__actions">
      <puro-button
        type="button"
        variant="link"
        size="small"
        [icon]="true"
        iconPosition="start"
        (buttonClick)="clearRow.emit(index())"
      >
        <puro-icon icon name="arrow-clockwise" size="sm" aria-hidden="true" />
        <span class="visually-hidden">{{
          'createShipment.packageStep.details.clearAria' | translate: { index: '' + (index() + 1) }
        }}</span>
        <span aria-hidden="true">{{ 'createShipment.packageStep.details.clear' | translate }}</span>
      </puro-button>
      @if (pieceCount() > 1) {
        <puro-button
          type="button"
          variant="link"
          size="small"
          [icon]="true"
          iconPosition="start"
          (buttonClick)="removeRow.emit(index())"
        >
          <puro-icon icon name="trash-delete" size="sm" aria-hidden="true" />
          <span class="visually-hidden">{{
            'createShipment.packageStep.details.deleteAria'
              | translate: { index: '' + (index() + 1) }
          }}</span>
          <span aria-hidden="true">{{
            'createShipment.packageStep.details.delete' | translate
          }}</span>
        </puro-button>
      }
    </div>
  </div>

  @for (key of [syncKey()]; track key) {
    <div class="customer-packaging-card__row customer-packaging-card__row--2">
      <puro-input
        class="customer-packaging-card__input"
        type="number"
        formControlName="identicalPieces"
        [label]="'createShipment.packageStep.details.identicalPieces' | translate"
        labelPosition="floating"
        [required]="true"
        [error]="hasError('identicalPieces')"
        [errorMessage]="
          hasError('identicalPieces') ? (fieldErrorKey('identicalPieces') | translate) : ''
        "
        [endAdornment]="true"
        (focusout)="onFieldBlur('identicalPieces')"
      >
        <span endAdornment class="customer-packaging-card__tooltip-icon">
          <span
            class="visually-hidden"
            [id]="'package-card-' + index() + '-identical-tooltip-desc'"
            >{{ 'createShipment.packageStep.details.identicalPiecesTooltip' | translate }}</span
          >
          <puro-tooltip
            #identicalPiecesTooltip
            [content]="'createShipment.packageStep.details.identicalPiecesTooltip' | translate"
          >
            <button
              type="button"
              class="customer-packaging-card__info-btn"
              [attr.aria-label]="
                'createShipment.packageStep.details.identicalPiecesTooltipAria' | translate
              "
              [attr.aria-describedby]="'package-card-' + index() + '-identical-tooltip-desc'"
              (click)="$event.preventDefault(); $event.stopPropagation()"
              (focus)="identicalPiecesTooltip.show()"
              (blur)="identicalPiecesTooltip.hide()"
            >
              <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
            </button>
          </puro-tooltip>
        </span>
      </puro-input>
      <puro-input
        class="customer-packaging-card__input customer-packaging-card__input--weight"
        type="text"
        formControlName="perPieceWeight"
        appPackageMeasureInput
        [label]="'createShipment.packageStep.details.perPieceWeight' | translate"
        labelPosition="floating"
        [required]="true"
        [endAdornment]="true"
        [error]="hasError('perPieceWeight')"
        [errorMessage]="
          hasError('perPieceWeight') ? (fieldErrorKey('perPieceWeight') | translate) : ''
        "
        (focusout)="onFieldBlur('perPieceWeight')"
      >
        <span endAdornment class="customer-packaging-card__unit">{{
          weightUnitLabelKey() | translate
        }}</span>
      </puro-input>
    </div>

    <div class="customer-packaging-card__dimension">
      <div class="customer-packaging-card__dimension-heading">
        <span class="customer-packaging-card__dimension-label"
          >{{ 'createShipment.packageStep.details.dimension' | translate
          }}<span class="customer-packaging-card__required" aria-hidden="true">*</span></span
        >
        <span class="customer-packaging-card__unit-chip">{{
          dimensionUnitLabelKey() | translate
        }}</span>
        <span
          class="visually-hidden"
          [id]="'package-card-' + index() + '-dimension-tooltip-desc'"
          >{{ 'createShipment.packageStep.details.dimensionTooltip' | translate }}</span
        >
        <puro-tooltip
          #dimTooltip
          [content]="'createShipment.packageStep.details.dimensionTooltip' | translate"
        >
          <button
            type="button"
            class="customer-packaging-card__info-btn"
            [attr.aria-label]="
              'createShipment.packageStep.details.dimensionTooltipAria' | translate
            "
            [attr.aria-describedby]="'package-card-' + index() + '-dimension-tooltip-desc'"
            (click)="$event.preventDefault(); $event.stopPropagation()"
            (focus)="dimTooltip.show()"
            (blur)="dimTooltip.hide()"
          >
            <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
          </button>
        </puro-tooltip>
      </div>
      <div class="customer-packaging-card__row customer-packaging-card__row--3">
        <puro-input
          class="customer-packaging-card__input"
          type="text"
          formControlName="length"
          appPackageMeasureInput
          [label]="'createShipment.packageStep.details.length' | translate"
          labelPosition="floating"
          [required]="true"
          [error]="hasError('length')"
          [errorMessage]="hasError('length') ? (fieldErrorKey('length') | translate) : ''"
          (focusout)="onFieldBlur('length')"
        />
        <puro-input
          class="customer-packaging-card__input"
          type="text"
          formControlName="width"
          appPackageMeasureInput
          [label]="'createShipment.packageStep.details.width' | translate"
          labelPosition="floating"
          [required]="true"
          [error]="hasError('width')"
          [errorMessage]="hasError('width') ? (fieldErrorKey('width') | translate) : ''"
          (focusout)="onFieldBlur('width')"
        />
        <puro-input
          class="customer-packaging-card__input"
          type="text"
          formControlName="height"
          appPackageMeasureInput
          [label]="'createShipment.packageStep.details.height' | translate"
          labelPosition="floating"
          [required]="true"
          [error]="hasError('height')"
          [errorMessage]="hasError('height') ? (fieldErrorKey('height') | translate) : ''"
          (focusout)="onFieldBlur('height')"
        />
      </div>
    </div>
  }

  <div class="customer-packaging-card__ah">
    <puro-checkbox
      class="customer-packaging-card__ah-checkbox"
      formControlName="requiresAdditionalHandling"
      [label]="'createShipment.packageStep.details.additionalHandling' | translate"
    />
    <span class="visually-hidden" [id]="'package-card-' + index() + '-ah-tooltip-desc'">{{
      'createShipment.packageStep.details.additionalHandlingTooltip' | translate
    }}</span>
    <puro-tooltip
      #ahTooltip
      [content]="'createShipment.packageStep.details.additionalHandlingTooltip' | translate"
    >
      <button
        type="button"
        class="customer-packaging-card__info-btn"
        [attr.aria-label]="
          'createShipment.packageStep.details.additionalHandlingTooltipAria' | translate
        "
        [attr.aria-describedby]="'package-card-' + index() + '-ah-tooltip-desc'"
        (click)="$event.preventDefault(); $event.stopPropagation()"
        (focus)="ahTooltip.show()"
        (blur)="ahTooltip.hide()"
      >
        <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
      </button>
    </puro-tooltip>
  </div>
</article>
